export const APP_CONNECT = 'APP_CONNECT';
export const CONNECTED_APPS_CHECK = 'CONNECTED_APPS_CHECK';
